module.exports = __webpack_public_path__ + "img/twitter-tweet-3.dcd4cce6.jpeg";